"use client";

import { redirect } from "next/navigation";
import { use } from "react";

/**
 * Releases redirect — the music/[id] page already handles both
 * individual tracks and releases from Firestore, so we redirect there.
 */
export default function ReleasePage({ params }: { params: Promise<{ id: string }> }) {
  const resolvedParams = use(params);
  redirect(`/music/${resolvedParams.id}`);
}
